(() => {
  if (customElements.get('hondo-card-swatches')) return;
  class HondoCardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product-item');
      if (!this.card) return;
      this.onClick = event => {
        const button = event.target.closest('[data-hondo-card-swatch]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(button);
      };
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.syncSelection());
      this.observer.observe(this.card, { attributes: true, attributeFilter: ['data-variant-id'] });
      this.syncSelection();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
    }
    syncSelection() {
      const id = this.card.dataset.variantId || this.dataset.defaultVariant;
      const color = this.card.dataset.variantifyColor;
      const url = this.card.querySelector('.product-item__image-link')?.getAttribute('href');
      this.querySelectorAll('[data-hondo-card-swatch]').forEach(button => {
        const selected = this.dataset.siblingSwatches === 'true'
          ? url?.split('?')[0].endsWith(button.dataset.hondoUrl.split('?')[0])
          : (color ? button.dataset.color === color : button.dataset.variantId === id);
        button.setAttribute('aria-pressed', String(Boolean(selected)));
      });
    }
    select(button) {
      const preview = button.parentElement.querySelector('template').content;
      const { hondoUrl: url, title, variantId, color } = button.dataset;
      const imageLink = this.card.querySelector('.product-item__image-link');
      if (!imageLink) return;
      this.card.dataset.variantId = variantId;
      if (this.card.hasAttribute('data-variantify-color')) this.card.dataset.variantifyColor = color;
      this.card.classList.add('hondo-card-color-selected');
      imageLink.replaceChildren(preview.querySelector('[data-preview-image]').firstElementChild.cloneNode(true));
      imageLink.setAttribute('aria-label', title);
      const titleLink = this.card.querySelector('.product-item__product-title a');
      if (titleLink) titleLink.textContent = title;
      this.card.querySelectorAll('.product-item__image-link, .product-item__product-title a').forEach(link => link.setAttribute('href', url));
      const price = this.card.querySelector('.product-item__text > .product-item__price');
      if (price) price.replaceChildren(...preview.querySelector('[data-preview-price]').cloneNode(true).childNodes);
      const badges = this.card.querySelector('.product-item__media > .product-badges');
      if (badges) badges.replaceWith(preview.querySelector('[data-preview-badges]').firstElementChild.cloneNode(true));
      this.card.querySelectorAll('[data-quick-shop-trigger], [data-hondo-selected-options]').forEach(trigger => {
        const link = document.createElement('a');
        link.className = trigger.className;
        link.href = url;
        link.dataset.hondoSelectedOptions = '';
        link.setAttribute('aria-label', title);
        link.append(...Array.from(trigger.childNodes).map(node => node.cloneNode(true)));
        trigger.replaceWith(link);
      });
      const status = this.querySelector('[data-swatch-status]');
      if (status) status.textContent = color;
      this.syncSelection();
    }
  }
  customElements.define('hondo-card-swatches', HondoCardSwatches);
})();
